<template>
  <div style="background-color: #F9FBFD;">
    <div class="certificate_header">
      <div class="certificate_header_img">
        <img src="../assets/banner-1.png" alt="">
      </div>
      <div class="certificate_header_title" id="certificate_header_title">
        <div class="certificate_header_box" @click="bandus">
          <span>师资培训</span>
        </div>
        <div class="certificate_header_box" style="color: #1D2B3E;'">
          <span>其他证书</span>
        </div>
        <div class="tab-activation-item" :style="{
                		left: (newleft + 338)+'px',
                	}"></div>
        <div class="certificate_header_title_board">
          <div style="font-size: 24px;color: #ffffff;margin-bottom: 7px;">Certificate Query</div>
          <div style="width: 48px;height: 3px;background-color: #ffffff;margin-bottom: 5px;"></div>
          <div style="font-size: 24px;color: #ffffff;">证书查询</div>
        </div>
      </div>
    </div>
    <div class="w">
      <div class="certificate">
        <div class="certificate-title" v-if="!imageflag">证书在线验证报告查询</div>
        <div class="certificate-box" v-if="!imageflag">
          <el-form ref="makeForm" :model="makeForm" :rules="makeFormRules" label-width="242px">
            <div class="login_header_box">
              <el-form-item prop="type" style="margin-bottom: 36px;" label="证书类型">
                <el-select v-model="makeForm.type" placeholder="请选择" style="width: 791px;">
                  <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="name" style="margin-bottom: 36px;" label="姓名">
                <el-input style="position: fixed;bottom: -9999px;">
                </el-input>
                <el-input v-model="makeForm.name" placeholder="请输入姓名" style="width: 791px;">
                </el-input>
              </el-form-item>
              <el-form-item style="margin-bottom: 36px;" label="单位">
                <el-input style="position: fixed;bottom: -9999px;">
                </el-input>
                <el-input v-model="makeForm.company" placeholder="请输入单位" style="width: 791px;">
                </el-input>
              </el-form-item>
              <el-form-item prop="certificateNum" style="margin-bottom: 36px;" label="证书编号 ">
                <el-input style="position: fixed;bottom: -9999px;">
                </el-input>
                <el-input v-model="makeForm.certificateNum" placeholder="请输入证书编号" style="width: 791px;">
                </el-input>
              </el-form-item>

              <div style="width: 100%;display: flex;justify-content: center;">
                <div class="btns" @click="Forget('makeForm')">
                  提交信息
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="certificate-title" v-if="imageflag">证书查询结果</div>
        <div class="demo-image__lazy" v-if="imageflag">
          <el-image :src="imageUrl" lazy :preview-src-list="srcList"></el-image>
        </div>
        <div style="width: 100%;display: flex;justify-content: center;margin-bottom: 36px;" v-if="imageflag">
          <div class="btns1" @click="imageflag = false">
            返回查询
          </div>
          <div class="btns" @click="downLoadImg(imageUrl,'证书')">
            下载证书
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        titIndex: 1,
        newwidth: 0,
        newheight: 4,
        newleft: 0,
        options: [{
          value: 0,
          label: 'A类'
        }, {
          value: 1,
          label: 'B类'
        }, {
          value: 2,
          label: 'C类'
        }],
        makeForm: {
          type: '',
          name: '',
          company: '',
          certificateNum: ''
        },
        makeFormRules: {
          type: [{
            required: true,
            message: '请选择证书类型',
            trigger: 'change'
          }],
          name: [{
            required: true,
            message: '请输入真实姓名',
            trigger: 'blur'
          }],
          certificateNum: [{
            required: true,
            message: '请输入证书编号',
            trigger: 'blur'
          }],
        },
        imageUrl: '',
        imageflag: false,
        srcList:[]
      }
    },

    watch: {

    },
    mounted() {
      this.init()
    },
    created() {
      this.getofficialtype()
    },
    methods: {
      async getofficialtype() {
        let res = await this.$Http.officialcertificatetype()
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.options = res.data.data
      },
      bandus() {
        window.open('https://cmea.org.cn/', '_blank')
      },
      init() {
        let data = document.getElementsByClassName('certificate_header_box')
        if (data.length) {
          let arr = []
          for (var i = 0; i < data.length; i++) {
            arr.push(data[i].clientWidth)
          }
          let titIndexnum = 0
          if (Number(this.titIndex) > 2) {
            this.newwidth = arr[Number(this.titIndex) - 3]
            titIndexnum = Number(this.titIndex) - 3
          } else {
            this.newwidth = arr[this.titIndex]
            titIndexnum = this.titIndex
          }

          this.newleft = arr.slice(0, titIndexnum).reduce((num, item) => {
            return num + item + 70
          }, 0)
          document.getElementById('certificate_header_title').scrollLeft = this.newleft - arr[this.titIndex] / 2;
        }
      },
      Forget() {
        this.$refs.makeForm.validate(async valid => {
          if (!valid) return
          let res = await this.$Http.officialcertificatequery(this.makeForm)
          if (res.data.result != 0) {
            this.$message.error(res.data.msg)
            return
          }
          this.imageUrl = res.data.data.imageUrl
          this.srcList = [res.data.data.imageUrl]
          this.imageflag = true
        })
      },
      downLoadImg(imgsrc, name) {
        var image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png",0.7); //得到图片的base64编码数据
          var a = document.createElement("a"); // 生成一个a元素
          var event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name?name+'.png':"photo.png"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
      }

    }

  }
</script>

<style lang="less" scoped>
  .w {
    width: 1200px !important;
    margin: 0 auto;
  }

  .certificate_header {
    width: 100%;
    position: relative;
  }

  .certificate_header_img {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .certificate_header_title {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
    height: 85px;
    padding-left: 348px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    background-color: #ffffff;
  }

  .certificate_header_box {
    display: inline-block;
    color: #808080;
    font-size: 16px;
    cursor: pointer;
    margin-right: 70px;
    z-index: 99;
  }

  .certificate_header_title_board {
    position: absolute;
    left: 0;
    top: -84px;
    width: 269px;
    height: 169px;
    background-color: #1A7BFC;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 27px;
  }

  .tab-activation-item {
    background: #1D2B3E;
    position: absolute;
    top: 41px;
    left: 0;
    z-index: 9;
    transition: all 0.3s linear;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .certificate-title {
    margin-top: 50px;
    font-size: 24px;
    font-weight: 600;
    color: #1D2B3E;
    width: 100%;
    text-align: center;
  }

  .certificate {
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    background-color: #FFFFFF;
    margin: 40px 0 0;

  }

  .login_header_box {
    margin: 40px 0 50px;
  }

  .login_header_box /deep/ .el-form-item__label:before {
    display: none !important;
  }

  .btns {
    display: inline-block;
    padding: 13px 39px;
    color: #FFFFFF;
    font-size: 14px;
    box-sizing: border-box;
    background: #1A7BFC;
    cursor: pointer;
  }

  .btns1 {
    display: inline-block;
    padding: 13px 39px;
    color: #1A7BFC;
    font-size: 14px;
    box-sizing: border-box;
    border: 1px solid #1A7BFC;
    cursor: pointer;
    margin-right: 36px;

  }

  .demo-image__lazy {
    width: 836px;
    margin: 36px auto;
  }
</style>
